const executeFunctionList = (
  functionList: (() => void)[],
) => () => {
  functionList.forEach((func) => { func(); });
};

export default executeFunctionList;
